import {Form} from 'antd'
import meta from './metaBm.mjs'
import Select from './SelectBm.jsx'

export const FormItemBm = props => (
    <Form.Item
        label={meta.name}
        name="bm"
        {...props}
    >
        <Select />
    </Form.Item>
)

export const FormItemBms = props => (
    <Form.Item
        label={meta.name}
        name="bms"
        {...props}
    >
        <Select multiple />
    </Form.Item>
)
